import { ReactElement, ReactNode } from 'react';
import { FormattedMessage } from 'intl';
import { TranslationKey } from 'intl/types/translationKey';
import { ImageDisplayStyle } from 'shared/domain/report/types/model/common';
import { SectionConfigOnView } from 'shared/domain/report/types/onView/common';
import { ReportContentListItem } from '../../formUi/presentational';
import { SectionAvailability, sectionUnavailableProps } from '../../model';
import { SectionRowPresentational } from '../presentational';
import { INSPECTION_REPORT_DISPLAY_STYLES } from '../adapters/sectionDisplayStyleOptions';

export function InspectionBooleanRow({
  icon,
  variant = 'default',
  showIcon = variant === 'default',
  labelId,
  enabled,
  onEnabledChange,
  sectionAvailability,
  'data-qa': dataQa,
}: {
  icon?: ReactNode;
  showIcon?: boolean;
  variant?: 'default' | 'nested';
  labelId: TranslationKey;
  enabled: boolean;
  onEnabledChange: (enabled: boolean) => void;
  sectionAvailability: SectionAvailability;
  'data-qa': string;
}): ReactElement {
  return (
    <ReportContentListItem
      icon={showIcon ? icon : undefined}
      variant={variant}
      title={<FormattedMessage id={labelId} />}
      switchAriaLabelId={labelId}
      enabled={enabled}
      onEnabledChange={onEnabledChange}
      data-qa={dataQa}
      {...sectionUnavailableProps(sectionAvailability)}
    />
  );
}

export function InspectionSectionRow({
  icon,
  variant = 'default',
  showIcon = variant === 'default',
  labelId,
  config,
  onConfigChange,
  sectionAvailability,
  onDisplayStyleChange,
  'data-qa': dataQa,
}: {
  icon?: ReactElement;
  showIcon?: boolean;
  variant?: 'default' | 'nested';
  labelId: TranslationKey;
  config: SectionConfigOnView;
  onConfigChange: (config: SectionConfigOnView) => void;
  sectionAvailability: SectionAvailability;
  onDisplayStyleChange: (displayStyle: ImageDisplayStyle) => void;
  'data-qa': string;
}): ReactElement {
  return (
    <SectionRowPresentational
      icon={showIcon ? icon : undefined}
      variant={variant}
      labelId={labelId}
      config={config}
      onConfigChange={onConfigChange}
      sectionAvailability={sectionAvailability}
      onDisplayStyleChange={onDisplayStyleChange}
      displayStyleOptions={INSPECTION_REPORT_DISPLAY_STYLES}
      data-qa={dataQa}
    />
  );
}
